const Icons = {
  check: 'e900',
  checks: 'e901',
  activesessions: 'e902',
  add: 'e903',
  add_reaction: 'e904',
  addboost: 'e905',
  addmember_filled: 'e906',
  adduser: 'e907',
  admin: 'e908',
  ads: 'e909',
  align_center: 'e90a',
  align_left: 'e90b',
  align_right: 'e90c',
  animals: 'e90d',
  animations: 'e90e',
  app_expand: 'e90f',
  app_shrink: 'e910',
  archive: 'e911',
  arrow_down: 'e912',
  arrow_next: 'e913',
  arrow_prev: 'e914',
  arrow_up_circle_fill: 'e915',
  arrowcircle: 'e916',
  arrowhead: 'e917',
  attach: 'e918',
  audio_repeat: 'e919',
  audio_repeat_single: 'e91a',
  author_hidden: 'e91b',
  avatarnext: 'e91c',
  avatarprevious: 'e91d',
  aversion: 'e91e',
  back: 'e91f',
  binfilled: 'e920',
  bold: 'e921',
  bomb: 'e922',
  boost: 'e923',
  boostcircle: 'e924',
  bot_filled: 'e925',
  botcom: 'e926',
  bots: 'e927',
  brightness: 'e928',
  brush: 'e929',
  bubblereply: 'e92a',
  bug: 'e92b',
  calendar: 'e92c',
  calendarfilter: 'e92d',
  camera: 'e92e',
  cameraadd: 'e92f',
  captiondown: 'e930',
  captionup: 'e931',
  car: 'e932',
  card: 'e933',
  card_outline: 'e934',
  cash_circle: 'e935',
  channel: 'e936',
  channel_filled: 'e937',
  channelviews: 'e938',
  chatspinned: 'e939',
  chatsplaceholder: 'e93a',
  check1: 'e93b',
  checkbox: 'e93c',
  checkboxblock: 'e93d',
  checkboxempty: 'e93e',
  checkboxon: 'e93f',
  checklist_add: 'e940',
  checklist_done: 'e941',
  checklist_undone: 'e942',
  checkretract: 'e943',
  checkround: 'e944',
  checkround_filled: 'e945',
  clock: 'e946',
  close: 'e947',
  clouddownload: 'e948',
  collapse: 'e949',
  colorize: 'e94a',
  comments: 'e94b',
  commentssticker: 'e94c',
  contrast: 'e94d',
  copy: 'e94e',
  crop: 'e94f',
  cross: 'e950',
  crossgif: 'e951',
  crossround: 'e952',
  crossround_filled: 'e953',
  crossstar: 'e954',
  crown: 'e955',
  crown_outline: 'e956',
  crownoff: 'e957',
  crownoff_outline: 'e958',
  darkmode: 'e959',
  data: 'e95a',
  delete: 'e95b',
  delete_filled: 'e95c',
  deletedaccount: 'e95d',
  deleteleft: 'e95e',
  deleteuser: 'e95f',
  devices: 'e960',
  document: 'e961',
  dollar_circle: 'e962',
  dollar_circle_x: 'e963',
  down: 'e964',
  down_up: 'e965',
  download: 'e966',
  dragfiles: 'e967',
  dragmedia: 'e968',
  eats: 'e969',
  edit: 'e96a',
  email: 'e96b',
  endcall_filled: 'e96c',
  enhance: 'e96d',
  enter: 'e96e',
  equalizer: 'e96f',
  expand: 'e970',
  eye: 'e971',
  eye1: 'e972',
  eye2: 'e973',
  eyecross_outline: 'e974',
  factcheck: 'e975',
  fade: 'e976',
  fast_forward: 'e977',
  fast_rewind: 'e978',
  favourites: 'e979',
  flag: 'e97a',
  flip: 'e97b',
  flip_image_horizontal: 'e97c',
  folder: 'e97d',
  fontframe: 'e97e',
  fontframe_bg: 'e97f',
  fontframe_outline: 'e980',
  fontsize: 'e981',
  forward: 'e982',
  forward_filled: 'e983',
  free_transform: 'e984',
  fullscreen: 'e985',
  gc_microphone: 'e986',
  gc_microphoneoff: 'e987',
  gem: 'e988',
  gem_exchange: 'e989',
  gem_transfer: 'e98a',
  gem_transfer_outline: 'e98b',
  geometric_digit_0: 'e98c',
  geometric_digit_1: 'e98d',
  geometric_digit_2: 'e98e',
  geometric_digit_3: 'e98f',
  geometric_digit_4: 'e990',
  geometric_digit_5: 'e991',
  geometric_digit_6: 'e992',
  geometric_digit_7: 'e993',
  geometric_digit_8: 'e994',
  geometric_digit_9: 'e995',
  geometric_dot: 'e996',
  geometric_letter_x: 'e997',
  gifs: 'e998',
  gift: 'e999',
  gift_premium: 'e99a',
  grain: 'e99b',
  group: 'e99c',
  group_filled: 'e99d',
  groupmedia: 'e99e',
  groupmediaoff: 'e99f',
  hand: 'e9a0',
  help: 'e9a1',
  hide: 'e9a2',
  highlights: 'e9a3',
  hourglass: 'e9a4',
  image: 'e9a5',
  image_original: 'e9a6',
  info: 'e9a7',
  info2: 'e9a8',
  italic: 'e9a9',
  key: 'e9aa',
  keyboard: 'e9ab',
  lamp: 'e9ac',
  language: 'e9ad',
  largepause: 'e9ae',
  largeplay: 'e9af',
  left: 'e9b0',
  limit_chat: 'e9b1',
  limit_chats: 'e9b2',
  limit_file: 'e9b3',
  limit_folders: 'e9b4',
  limit_link: 'e9b5',
  limit_pin: 'e9b6',
  link: 'e9b7',
  link_paid: 'e9b8',
  list: 'e9b9',
  listscreenshare: 'e9ba',
  livelocation: 'e9bb',
  location: 'e9bc',
  lock: 'e9bd',
  lockoff: 'e9be',
  loginlogodesktop: 'e9bf',
  loginlogomobile: 'e9c0',
  logout: 'e9c1',
  mac_command_key: 'e9c2',
  mediaspeed_empty: 'e9c3',
  mediaspoiler: 'e9c4',
  mediaspoileroff: 'e9c5',
  mention: 'e9c6',
  menu: 'e9c7',
  menu_feature_cover: 'e9c8',
  menu_feature_unique: 'e9c9',
  menu_verification: 'e9ca',
  message: 'e9cb',
  message_jump: 'e9cc',
  message_quote: 'e9cd',
  messageunread: 'e9ce',
  microphone: 'e9cf',
  microphone_crossed: 'e9d0',
  microphone_crossed_filled: 'e9d1',
  microphone_filled: 'e9d2',
  minus: 'e9d3',
  monospace: 'e9d4',
  more: 'e9d5',
  multistories: 'e9d6',
  mute: 'e9d7',
  muted: 'e9d8',
  mynotes: 'e9d9',
  newchannel: 'e9da',
  newchannel_filled: 'e9db',
  newchat_filled: 'e9dc',
  newgroup: 'e9dd',
  newgroup_filled: 'e9de',
  newprivate: 'e9df',
  newprivate_filled: 'e9e0',
  newtab: 'e9e1',
  next: 'e9e2',
  nochannel: 'e9e3',
  noncontacts: 'e9e4',
  nosound: 'e9e5',
  online: 'e9e6',
  passwordoff: 'e9e7',
  pause: 'e9e8',
  permissions: 'e9e9',
  person: 'e9ea',
  phone: 'e9eb',
  phone_filled: 'e9ec',
  pin: 'e9ed',
  pin2: 'e9ee',
  pinlist: 'e9ef',
  pinned_filled: 'e9f0',
  pinnedchat: 'e9f1',
  pip: 'e9f2',
  play: 'e9f3',
  playback_05: 'e9f4',
  playback_15: 'e9f5',
  playback_1x: 'e9f6',
  playback_2x: 'e9f7',
  plus: 'e9f8',
  plusround: 'e9f9',
  poll: 'e9fa',
  premium_addone: 'e9fb',
  premium_avatars: 'e9fc',
  premium_badge: 'e9fd',
  premium_colors: 'e9fe',
  premium_double: 'e9ff',
  premium_emoji: 'ea00',
  premium_filesize: 'ea01',
  premium_lastseen: 'ea02',
  premium_limits: 'ea03',
  premium_lock: 'ea04',
  premium_management: 'ea05',
  premium_noads: 'ea06',
  premium_privacy: 'ea07',
  premium_reactions: 'ea08',
  premium_restrict: 'ea09',
  premium_speed: 'ea0a',
  premium_status: 'ea0b',
  premium_stickers: 'ea0c',
  premium_tags: 'ea0d',
  premium_transcription: 'ea0e',
  premium_translate: 'ea0f',
  premium_unlock: 'ea10',
  premium_wallpaper: 'ea11',
  previous: 'ea12',
  promote: 'ea13',
  quote: 'ea14',
  quote_outline: 'ea15',
  radiooff: 'ea16',
  radioon: 'ea17',
  reactions: 'ea18',
  reactions_filled: 'ea19',
  readchats: 'ea1a',
  recent: 'ea1b',
  redo: 'ea1c',
  replace: 'ea1d',
  reply: 'ea1e',
  reply_filled: 'ea1f',
  restrict: 'ea20',
  revenue: 'ea21',
  rightpanel: 'ea22',
  rotate: 'ea23',
  rotate_left: 'ea24',
  rotate_right: 'ea25',
  round_chats_filled: 'ea26',
  saturation: 'ea27',
  saved: 'ea28',
  savedmessages: 'ea29',
  schedule: 'ea2a',
  scheduled: 'ea2b',
  search: 'ea2c',
  select: 'ea2d',
  send: 'ea2e',
  send2: 'ea2f',
  sending: 'ea30',
  sendingerror: 'ea31',
  settings: 'ea32',
  settings_clipped_corner: 'ea33',
  settings_filled: 'ea34',
  shadows: 'ea35',
  sharescreen_filled: 'ea36',
  sharpen: 'ea37',
  shipping: 'ea38',
  shuffle: 'ea39',
  smallscreen: 'ea3a',
  smile: 'ea3b',
  sort_date: 'ea3c',
  sort_num: 'ea3d',
  sort_price: 'ea3e',
  speaker: 'ea3f',
  speakerfilled: 'ea40',
  speakeroff: 'ea41',
  speakerofffilled: 'ea42',
  spoiler: 'ea43',
  sport: 'ea44',
  star: 'ea45',
  star_filled: 'ea46',
  statistics: 'ea47',
  stickers: 'ea48',
  stickers_face: 'ea49',
  stop: 'ea4a',
  stories: 'ea4b',
  storyreply: 'ea4c',
  storyrepost: 'ea4d',
  strikethrough: 'ea4e',
  suggested: 'ea4f',
  tag: 'ea50',
  tag_add: 'ea51',
  tag_alt: 'ea52',
  tag_alt_crossed: 'ea53',
  tag_alt_outline: 'ea54',
  tag_crossed: 'ea55',
  tag_filter: 'ea56',
  tag_name: 'ea57',
  text: 'ea58',
  textedit: 'ea59',
  time_lock: 'ea5a',
  timer: 'ea5b',
  tip: 'ea5c',
  ton: 'ea5d',
  tools: 'ea5e',
  topics: 'ea5f',
  trade: 'ea60',
  transcribe: 'ea61',
  unarchive: 'ea62',
  unclaimed: 'ea63',
  underline: 'ea64',
  undo: 'ea65',
  unmute: 'ea66',
  unpack: 'ea67',
  unpin: 'ea68',
  unread: 'ea69',
  up: 'ea6a',
  up_down: 'ea6b',
  user: 'ea6c',
  username: 'ea6d',
  videocamera: 'ea6e',
  videocamera_crossed_filled: 'ea6f',
  videocamera_filled: 'ea70',
  videochat: 'ea71',
  vignette: 'ea72',
  volume_down: 'ea73',
  volume_mute: 'ea74',
  volume_off: 'ea75',
  volume_up: 'ea76',
  warmth: 'ea77',
  webview: 'ea78',
  win_key: 'ea79',
  zoomin: 'ea7a',
  zoomout: 'ea7b'
};

export default Icons;
